var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4787 4.06785C11.6389 4.20962 11.7902 4.36098 11.932 4.5211L13.6397 4.76495C13.9166 5.24717 14.1301 5.76312 14.2749 6.3L13.2402 7.67949C13.2402 7.67949 13.2532 8.10696 13.2403 8.32041L14.2753 9.70033C14.1302 10.2371 13.9163 10.7529 13.6391 11.235L11.932 11.4788C11.932 11.4788 11.6389 11.7902 11.4788 11.932L11.235 13.6397C10.7528 13.9166 10.2368 14.1301 9.69994 14.2749L8.32054 13.2403C8.10707 13.2532 7.89301 13.2532 7.67954 13.2403L6.29962 14.2753C5.76283 14.1302 5.24703 13.9163 4.765 13.6391L4.5212 11.9321C4.36108 11.7903 4.20971 11.639 4.06794 11.4788L2.36029 11.235C2.08337 10.7528 1.86986 10.2368 1.72506 9.69994L2.75971 8.32046C2.75971 8.32046 2.7467 7.89299 2.75967 7.67954L1.72461 6.29962C1.86977 5.76283 2.08363 5.24702 2.36088 4.765L4.06785 4.5212C4.20962 4.36108 4.36098 4.20971 4.5211 4.06794L4.76495 2.36029C5.24717 2.08337 5.76312 1.86986 6.3 1.72506L7.67941 2.75968C7.89288 2.7467 8.10694 2.7467 8.32041 2.75967L9.70033 1.72461C10.2371 1.86977 10.7529 2.08363 11.235 2.36088L11.4787 4.06785Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.e7cf5872a4ac6c33f943fde35eb14178.svg";
export { ForwardRef as ReactComponent };